import React, {useEffect, useState} from "react";
import {motion} from "framer-motion";
import {useParams} from "react-router";

const SimulationSSM = () => {
    const {id} = useParams();
    const [simulation, setSimulation] = useState([]);
    const [indexSimulation, setIndexSimulation] = useState(0);
    const [selectAnswer, setSelectAnswer] = useState(null);
    const [verify, setVerify] = useState(null); // null | true | false

    useEffect(() => {
        fetch(`/simulations/simulation_${id}.json`)
            .then(res => res.json())
            .then(setSimulation)
            .catch(err => console.error('Errore nel caricamento:', err));
    }, [id]);

    const currentSimulation = simulation[indexSimulation];

    const indexSimulationNext = () => {
        if (indexSimulation < simulation.length - 1) {
            setIndexSimulation(indexSimulation + 1);
        }
        setSelectAnswer(null);
        setVerify(null);
    };

    const indexSimulationPrevious = () => {
        if (indexSimulation > 0) {
            setIndexSimulation(indexSimulation - 1);
        }
        setSelectAnswer(null);
        setVerify(null);
    };

     const answerConfirm = () => {
         if (selectAnswer !== null && currentSimulation?.corretta) {
             setVerify(selectAnswer === currentSimulation.corretta);
         }
     };

    return (
        <motion.div className="container my-4">
            <h2 className={"text-center mb-4"}>Simulazione: {id}</h2>
            <hr/>
            {currentSimulation && (
                <div className="card border rounded shadow-sm">
                    <div className={"card-header py-3"}>
                        <h5 className={"mb-0"}>Domanda {indexSimulation + 1}. {currentSimulation.domanda}</h5>
                    </div>
                    <div className={"card-body"}>
                        {currentSimulation.foto1 &&
                            <div className={"text-center mb-2"}><img src={"/images/simulations/" + currentSimulation.foto1}/></div>
                        }
                        {currentSimulation.scenario && <p>{currentSimulation.scenario}</p>}
                        <ul className="list-group">
                            {[1, 2, 3, 4, 5].map(i =>
                                currentSimulation[`risposta${i}`] ? (
                                    <li key={i} className={`list-group-item ${selectAnswer === i ? 'active' : ''}`}
                                        style={{cursor: 'pointer'}} onClick={() => setSelectAnswer(i)}>
                                        <strong>{String.fromCharCode(64 + i)}:</strong> {currentSimulation[`risposta${i}`]}
                                    </li>
                                ) : null
                            )}
                        </ul>
                        <hr/>
                        <div className={"text-center"}>
                            <button className="btn btn-success" onClick={answerConfirm} disabled={selectAnswer === null}>
                                Conferma risposta
                            </button>
                        </div>
                        {verify !== null && (
                            <div className={`alert mt-3 ${verify ? 'alert-success' : 'alert-danger'}`}>
                                {verify ? 'Risposta corretta ✅' : `Risposta sbagliata ❌ - Corretta: ${String.fromCharCode(64 + currentSimulation.corretta)}`}
                                <div className="mt-2"><i>{currentSimulation.commento}</i></div>
                            </div>
                        )}
                    </div>
                    <div className={"card-footer"}>
                        <div className="d-flex justify-content-between mt-4">
                            <button className="btn btn-secondary" onClick={indexSimulationPrevious}
                                    disabled={indexSimulation === 0}>← Precedente
                            </button>
                            <span className={"fw-lighter"}>{indexSimulation + 1} di {simulation.length}</span>
                            <button className="btn btn-primary" onClick={indexSimulationNext}
                                    disabled={indexSimulation === simulation.length - 1}>Successiva →
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </motion.div>
    );
}

export default SimulationSSM;